<div class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10" *transloco="let t; read: 'auth.login'">
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />

  <div class="relative z-10 w-[640px] rounded-[5px] bg-white p-8">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" [ngClass]="{ 'blur-md': isLoading }">
      <div class="mb-[84px] flex flex-col gap-4">
        <app-form-element
          [label]="t('form.email')"
          [labelFor]="'email'"
          [validationMessages]="{ userNotFound: t('validation.userNotFound') }"
          [showRequiredAsterisk]="false"
        >
          <input class="form-control" id="email" type="email" autocapitalize="off" autocorrect="off" formControlName="email" />
        </app-form-element>
        <div>
          <app-form-element
            [label]="t('form.password')"
            [labelFor]="'password'"
            [validationMessages]="{ wrongPassword: t('validation.invalidCredentials') }"
            [showRequiredAsterisk]="false"
          >
            <input appTogglePassword class="form-control" id="password" type="password" formControlName="password" />
          </app-form-element>
        </div>
      </div>

      <div class="pb-8">
        <button type="submit" [disabled]="isLoading || loginForm.invalid" class="btn btn-primary w-full justify-center">
          {{ t('button.signIn') }}
        </button>
      </div>

      <div class="flex justify-between">
        <a [href]="registrationLandingUrl" (click)="onRegistrationClick($event)" class="!text-small-regular text-gray-600">
          {{ t('links.register') }}
        </a>
        <a routerLink="/auth/forgot-password" class="!text-small-bold text-primary"> {{ t('links.passwordRecovery') }} </a>
      </div>
    </form>
    @if (isLoading) {
      <div class="absolute top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
        <app-loader color="blue"></app-loader>
      </div>
    }
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
